import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState<'privacy' | 'terms'>('privacy');
  const openModal = (type: 'privacy' | 'terms') => {
    setModalContent(type);
    setModalOpen(true);
  };
  const privacyContent = <>
      <p data-id="element-109">
        <strong data-id="element-110">1. Información que recopilamos</strong>
        <br data-id="element-111" />
        Recopilamos información necesaria para procesar su compra y entregar el
        producto digital, incluyendo nombre y correo electrónico. No almacenamos
        información financiera completa.
      </p>

      <p data-id="element-112">
        <strong data-id="element-113">2. Uso de la información</strong>
        <br data-id="element-114" />
        Utilizamos su información únicamente para entregar el producto, enviar
        actualizaciones relacionadas y mejorar nuestros servicios.
      </p>

      <p data-id="element-115">
        <strong data-id="element-116">3. Protección de datos</strong>
        <br data-id="element-117" />
        Implementamos medidas de seguridad estándar de la industria para
        proteger su información personal contra acceso no autorizado.
      </p>

      <p data-id="element-118">
        <strong data-id="element-119">4. Cookies</strong>
        <br data-id="element-120" />
        Utilizamos cookies esenciales para el funcionamiento del carrito de
        compras y análisis anónimo de tráfico.
      </p>
    </>;
  const termsContent = <>
      <p data-id="element-121">
        <strong data-id="element-122">1. Aceptación</strong>
        <br data-id="element-123" />
        Al comprar este producto, usted acepta estos términos y condiciones en
        su totalidad.
      </p>

      <p data-id="element-124">
        <strong data-id="element-125">2. Producto digital</strong>
        <br data-id="element-126" />
        "La Biblia del Café" es un producto 100% digital. No se enviará ningún
        producto físico.
      </p>

      <p data-id="element-127">
        <strong data-id="element-128">3. Política de reembolso</strong>
        <br data-id="element-129" />
        Ofrecemos una garantía de satisfacción de 30 días. Si no está
        satisfecho, puede solicitar un reembolso completo dentro de este
        período.
      </p>

      <p data-id="element-130">
        <strong data-id="element-131">4. Propiedad intelectual</strong>
        <br data-id="element-132" />
        Todo el contenido está protegido por derechos de autor. La
        redistribución o reventa está estrictamente prohibida.
      </p>

      <p data-id="element-133">
        <strong data-id="element-134">5. Limitación de responsabilidad</strong>
        <br data-id="element-135" />
        El autor no se hace responsable por el uso indebido de la información
        proporcionada en la guía.
      </p>
    </>;
  return <>
      <footer className="bg-[#111827] text-[#aaa] text-center py-[30px] px-[15px] text-[12px]" data-id="element-136">
        <p className="mb-4" data-id="element-137">© 2025 - La Biblia del Café | Método BÍBLICO™</p>
        <div className="flex justify-center gap-6 text-[11px]" data-id="element-138">
          <button onClick={() => openModal('privacy')} className="text-gray-500 hover:text-gray-300 underline transition-colors" data-id="element-139">
            Política de Privacidad
          </button>
          <button onClick={() => openModal('terms')} className="text-gray-500 hover:text-gray-300 underline transition-colors" data-id="element-140">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      <LegalModal isOpen={modalOpen} onClose={() => setModalOpen(false)} title={modalContent === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'} content={modalContent === 'privacy' ? privacyContent : termsContent} data-id="element-141" />
    </>;
}